/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import CardMedia from '@mui/material/CardMedia';
import Container from '@mui/material/Container';
import PropTypes from 'prop-types';
import React from 'react';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function Banner({ imageUrl }) {
  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <Container sx={{ p: 0 }}>
      <CardMedia component="img" height="auto" image={imageUrl} data-testid="banner-image" />
    </Container>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
Banner.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default Banner;
